import { useState } from "react";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Tooltip } from "@mui/material";
import Popover from "@mui/material/Popover";

import RibbonElementCommon from "./RibbonElementCommon.jsx";

const RibbonElementSeparateSelect = ({ elementSettings }) => {
	const { name, callback, _children, icon, isDisabled, nameVisible, size, styles, attrClass } = elementSettings;
	const [anchorEl, setAnchorEl] = useState(null);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);

	return (
		<div className="ribbon-element-select-wrapper">
			<Tooltip title={nameVisible && name}>
				<span>
					<button
						className={size === "large" ? "ribbon-element-select ribbon-element-select__large" : "ribbon-element-common"}
						disabled={isDisabled}
						onClick={callback}
						style={styles?.mainButton}
					>
						{icon}
						{!nameVisible && name}
					</button>
					<button
						className="ribbon-element-arrow-select"
						disabled={isDisabled}
						onClick={handleClick}
						style={styles?.subButton}
						attr={attrClass}
					>
						<ArrowDropDownIcon className={size === "large" ? "ribbon-element-select-svg__large" : ""} />
					</button>
				</span>
			</Tooltip>

			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				onClick={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
			>
				<div className="ribbon-select-options">
					{_children.map((child, index) => (
						<RibbonElementCommon key={index} elementSettings={child} />
					))}
				</div>
			</Popover>
		</div>
	);
};

export default RibbonElementSeparateSelect;
